export default __webpack_public_path__ + "RobotoCondensed-BoldItalic.4a217d1dfaa205c5c5cd37a0e582fb79.ttf";